<div (scrollFinished)="isRequiredScrollToComment && startBlinkAnimation()"
     *ngIf="comment"
     [@doubleBlink]="blinkState"
     [appScrollIntoView]="isRequiredScrollToComment"
     class="flex-row gap-15 p-15 borderTop"
     classTarget="commentTarget">
    <ng-container *ngIf="!isMobile">
        <ng-container *ngIf="comment.author  && comment.author?.id > 0 else anonymous">
            <div [appUserAvatar]="comment.author" [matMenuTriggerFor]="menu"
                 (menuOpened)="this.userInfoMenuOpen = true" (menuClosed)="this.userInfoMenuOpen = false"
                 class="miniInitial bg-primary mb-0 clickable"
                 mat-card-avatar>
            </div>
            <mat-menu #menu="matMenu" class="userDisplayMenu">
                <ng-container *ngIf="userInfoMenuOpen">
                    <app-user-info [user]="comment.author"></app-user-info>
                </ng-container>
            </mat-menu>
        </ng-container>
    </ng-container>
    <div class="flex-col w-100 commentTarget">
        <div class="flex-row flex-space-between flex-wrap">
            <ng-container *ngIf="isMobile">
                <ng-container *ngIf="comment.author  && comment.author?.id > 0 && isMobile else anonymous">
                    <div [appUserAvatar]="comment.author" [matMenuTriggerFor]="menu"
                         (menuOpened)="this.userInfoMenuOpen = true" (menuClosed)="this.userInfoMenuOpen = false"
                         class="miniInitial bg-primary mb-0 clickable"
                         mat-card-avatar>
                    </div>
                    <mat-menu #menu="matMenu" class="userDisplayMenu">
                        <ng-container *ngIf="userInfoMenuOpen">
                            <app-user-info [user]="comment.author"></app-user-info>
                        </ng-container>
                    </mat-menu>
                </ng-container>
            </ng-container>
            <div class="flex-row align-items-center gap-15">
                <mat-icon *ngIf="child" class="replyIcon" matTooltip="Comment reply">reply</mat-icon>
                <p class="m-0">{{ comment.author?.username || 'Anonymous' }}</p>
                <small class="muted">{{ comment.created_at | relativeTime }}</small>
            </div>
            <div class="flex-row gap-5">
                <mat-chip *ngIf="comment.is_anonymous && !userIsNotCommentAuthor" class="noCursorEvents">Posted
                    Anonymously
                </mat-chip>

                <button (click)="moderateComment()"
                        *ngIf="(isSuperuser || hasCommunityRole(['full_admin', 'moderator'])) && !comment.moderated"
                        aria-label="Mark as moderated"
                        class="delete-icon-button"
                        mat-icon-button matTooltip="Mark as moderated">
                    <mat-icon>check_circle</mat-icon>
                </button>

                <button (click)="reportComment()"
                        *ngIf="(isSuperuser || hasCommunityRole(['full_admin', 'moderator', 'client'])) && userIsNotCommentAuthor && !comment.is_flagged_for_review"
                        aria-label="Report comment" class="delete-icon-button"
                        mat-icon-button matTooltip="Flag comment">
                    <mat-icon>report</mat-icon>
                </button>

                <button (click)="unflagComment()"
                        *ngIf="(isSuperuser || hasCommunityRole(['full_admin'])) && comment.is_flagged_for_review"
                        aria-label="Report comment"
                        class="delete-icon-button"
                        mat-icon-button matTooltip="Un-flag comment">
                    <mat-icon>report_off</mat-icon>
                </button>


                <button (click)="hideComment()"
                        *ngIf="(isSuperuser || hasCommunityRole(['full_admin'])) && comment.hidden"
                        aria-label="Show comment"
                        class="delete-icon-button"
                        mat-icon-button matTooltip="Show comment">
                    <mat-icon>speaker_notes</mat-icon>
                </button>
                <button (click)="hideComment()"
                        *ngIf="(isSuperuser || hasCommunityRole(['full_admin'])) && !comment.hidden"
                        aria-label="Hide comment"
                        class="delete-icon-button"
                        mat-icon-button matTooltip="Hide comment">
                    <mat-icon>speaker_notes_off</mat-icon>
                </button>

                <button (click)="deleteComment()" *ngIf="userCanDeleteComment || !userIsNotCommentAuthor"
                        aria-label="Delete comment"
                        class="delete-icon-button"
                        mat-icon-button matTooltip="Delete comment">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
        </div>
        <div *ngIf="(isSuperuser || hasCommunityRole(['full_admin'])) && (comment.hidden || comment.is_flagged_for_review || !comment.moderated)"
             class="flex-row gap-15">
            <div *ngIf="comment.hidden" class="commentStatus">Hidden</div>
            <div *ngIf="comment.is_flagged_for_review" class="commentStatus">Flagged for review</div>
            <div *ngIf="!comment.moderated" class="commentStatus">Un-Moderated</div>
        </div>
        <div *ngIf="!userIsNotCommentAuthor && !comment.moderated && community.hide_unmoderated"
             class="flex-row gap-15">
            <div *ngIf="comment.hidden" class="commentStatus">Hidden</div>
            <div *ngIf="comment.is_flagged_for_review" class="commentStatus">Flagged for review</div>
            <div *ngIf="!comment.moderated" class="commentStatus">Awaiting Moderation</div>
        </div>
        <!--        app-post-content now works for dynamic content of comments also-->
        <app-post-content *ngIf="!editing" [content]="comment" [disableOverlay]="true"
                          [isCommentStyle]="true"></app-post-content>
        <app-reply-field (action)="updateComment($event)" *ngIf="editing" [initialCommentData]="comment"
                         [isOpenState]="true" [post]="post"></app-reply-field>
        <!--        <ng-container *ngIf="editing">-->
        <!--            <div class="d-flex flex-row w-100 gap-10 mt-10">-->
        <!--                <div class="flex-auto">-->
        <!--                    <mat-form-field appearance="outline" class="whiteField w-100" color="primary">-->
        <!--                    <textarea matInput maxlength="400" required [formControl]="commentEdit"-->
        <!--                              rows="3"></textarea>-->
        <!--                        <mat-error>-->
        <!--                            This field is required-->
        <!--                        </mat-error>-->
        <!--                    </mat-form-field>-->
        <!--                </div>-->
        <!--                <div class="flex-col flex-space-between"-->
        <!--                     *ngIf=" post.emoji_enabled && this.selectedCommunity?.emoji_enabled">-->
        <!--                    <app-emoji-menu [formControl]="commentEdit" ngDefaultControl matSuffix></app-emoji-menu>-->
        <!--                </div>-->

        <!--            </div>-->
        <!--        </ng-container>-->
        <div *ngIf="!editing" class="flex-row actionsRow flex-wrap">
            <button (click)="likeComment(comment)" [class.empty-state]="!comment.is_liked"
                    [class.mat-mdc-raised-button]="comment.is_liked ? community?.like_comment_button_bg_color_hex: ''"
                    [disabled]="post.likes_off || !(userIsNotCommentAuthor && (isSuperuser || hasCommunityRole(['full_admin', 'moderator', 'member'])))"
                    [style.background-color]="comment.is_liked ?community?.like_comment_button_bg_color_hex: ''"
                    [style.color]="comment.is_liked ?this.themeService.getReadableColor(community?.like_comment_button_bg_color_hex): ''"
                    class="comment-action-btn"
                    mat-button>
                <mat-icon [@likeAnimation]="comment.is_liked ? 'active' : 'inactive'">thumb_up</mat-icon>
                {{ comment.likes_count }}
            </button>
            <button (click)="dislikeComment(comment)" [class.empty-state]="!comment.is_disliked"
                    [class.mat-mdc-raised-button]="comment.is_disliked ?community?.dislike_comment_button_bg_color_hex: ''"
                    [disabled]="post.likes_off || !(userIsNotCommentAuthor && (isSuperuser || hasCommunityRole(['full_admin', 'moderator', 'member'])))"
                    [style.background-color]="comment.is_disliked? community?.dislike_comment_button_bg_color_hex: ''"
                    [style.color]="comment.is_disliked? this.themeService.getReadableColor(community?.dislike_comment_button_bg_color_hex): ''"
                    class="comment-action-btn"
                    mat-button>
                <mat-icon [@likeAnimation]="comment.is_disliked ? 'active' : 'inactive'">thumb_down</mat-icon>
                {{ comment.dislikes_count }}
            </button>
            <button (click)="editComment()" *ngIf="isSuperuser || !userIsNotCommentAuthor" class="comment-action-btn"
                    mat-button>
                <mat-icon>edit</mat-icon>
                Edit Comment
            </button>

            <button (click)="!post.comments_off && replyComment(comment)"
                    *ngIf="isSuperuser || hasCommunityRole(['full_admin']) || (hasCommunityRole(['client', 'member']))"
                    [disabled]="post.comments_off" class="comment-action-btn"
                    mat-button>
                <mat-icon>chat_bubble</mat-icon>
                Reply
            </button>
            <button (click)="comment.minimiseReplies = !comment.minimiseReplies"
                    *ngIf="comment?.children?.length > 0 && !community?.disable_comment_collapsing"
                    class="comment-action-btn"
                    mat-button>
                <ng-container *ngIf="!comment.minimiseReplies">
                    <mat-icon>expand_less</mat-icon>
                    Hide Replies ({{ comment?.children?.length }})
                </ng-container>
                <ng-container *ngIf="comment.minimiseReplies">
                    <mat-icon>expand_more</mat-icon>
                    Show Replies ({{ comment?.children?.length }})
                </ng-container>
            </button>
        </div>
    </div>
</div>
<app-reply-field *ngIf="comment && (replyCommentId | async) === comment.id" [isOpenState]="true" [isReply]="true"
                 [post]="post"
                 class="d-block ml-20"></app-reply-field>


<ng-template #anonymous>
    <div class="miniInitial bg-primary mb-0" mat-card-avatar matTooltip="This post was posted anonymously">A
    </div>
</ng-template>
